import { accessRole } from "../../../../helpers/access_role";
import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  Alert, CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Fieldset,
  Legend,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import { FileInput1 } from "../../../../helpers/ui/FileInput1";

import Select from "../../../../helpers/ui/CustomSelect";
import CustomSelect from "../../../../helpers/ui/CustomSelect"
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import moment from "moment";

import { Link, useHistory, Redirect } from "react-router-dom";

import apiResponse from "../../../../services/apiResponse";

import CreateBloc from "./Blocs/CreateBloc";

class IndexView extends Component {
  createBloc = new CreateBloc();
  timer;

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
      employeeOptions:[],
      existingSkpData: [],
      positionOptions:[],
      optcriteria: [],
      monthOptions: this.createMonthOptions(),
      yearOptions: this.createYearOption(new Date().getFullYear() - 30),
      month: localStorage.getItem(this.historyMonth)
        ? JSON.parse(localStorage.getItem(this.historyMonth))
        : moment().format("M"),
      year: localStorage.getItem(this.historyYear)
        ? JSON.parse(localStorage.getItem(this.historyYear))
        : moment().format("YYYY"),
        is_pltplh:null,
        position_name:'',
        hasilperilakuOption: [
          {'label': 'Di atas','value':'Di atas'},
          {'label': 'Sesuai','value':'Sesuai'},
          {'label': 'Di bawah','value':'Di bawah'},
        ]
    };
  }

  createMonthOptions() {
    var months = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember",
    ];

    return months.map(function (month, i) {
      var newObj = {};
      newObj["label"] = month;
      newObj["value"] = ++i;

      return newObj;
    });
  }
  createYearOption(startYear = 2000) {
    var currentYear = new Date().getFullYear(),
      years = [];
    startYear = startYear || 1980;
    while (startYear <= currentYear) {
      var newObj = {};
      var year = startYear++;
      newObj["label"] = year;
      newObj["value"] = year;
      years.push(newObj);
    }
    return years;
  }

  convertToFormData(data) {
    const formData = new FormData();

    for (const key in data) {
      const value = data[key];
      if (value !== null && value !== undefined) {
        if (Array.isArray(value)) {
          value.forEach((item, index) => {
            if (Array.isArray(item)) {
              item.forEach((itm, idx) => {
                if (itm !== null && itm !== undefined) {
                  formData.append(`${key}[${index}][]`, itm);
                }
              });
            } else {
              formData.append(`${key}[]`, item);
            }
          });
        } else {
          formData.append(key, value);
        }
      }
    }

    return formData;
  }

  reformatOptionsEmployee = (raw, label, value) => {
      return raw.map(function(data) {
        var newObj = {};
        newObj["label"] = data['employee_nip'] +' - '+ data[label];
        newObj["value"] = data[value];
        newObj["model"] = data;
    
        return newObj;
      });
  };

  reformatOptions = (raw, label, value) => {
      return raw.map(function(data) {
        var newObj = {};
        newObj["label"] = data[label];
        newObj["value"] = data[value];
        newObj["model"] = data;
    
        return newObj;
      });
  };
  
  submitData = async () => {
    // await this.createBloc.fetchCreatepernip(
    //   this.convertToFormData(this.state.dataForm)
    // );
    const formData = generateFormData(this.state.dataForm, 'file_doc') // Jika nama field fileinputnya adalah 'File', maka parameter kedua boleh dikosongkan. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto'] 

        await this.createBloc.fetchCreatepernip(formData)
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
      },
      confirm: true,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };
  getposition = (nip) =>{
    this.createBloc.fetchPosition({month:this.state.month,year:this.state.year,nip:nip})
  }

  calculateHasilAkhir = (hk, pk) => {
    if (!hk || !pk) return;
    let hkLower = hk.toLowerCase().trim();
    let pkLower = pk.toLowerCase().trim();
    
    let result = "";
    const rules = this.state.mappingRules;
    if (rules && rules.length > 0) {
        for (let i = 0; i < rules.length; i++) {
            if (rules[i].hasil_kerja.toLowerCase().trim() === hkLower && 
                rules[i].perilaku_kerja.toLowerCase().trim() === pkLower) {
                result = rules[i].hasil_akhir;
                break;
            }
        }
    }

    // Fallback if mapping not found in DB
    if (!result) {
        if (hkLower === 'di atas' && pkLower === 'di atas') result = 'Sangat Baik';
        else if (hkLower === 'di atas' && pkLower === 'sesuai') result = 'Baik';
        else if (hkLower === 'di atas' && pkLower === 'di bawah') result = 'Kurang';
        else if (hkLower === 'sesuai' && pkLower === 'di atas') result = 'Baik';
        else if (hkLower === 'sesuai' && pkLower === 'sesuai') result = 'Baik';
        else if (hkLower === 'sesuai' && pkLower === 'di bawah') result = 'Kurang';
        else if (hkLower === 'di bawah' && pkLower === 'di atas') result = 'Butuh Perbaikan';
        else if (hkLower === 'di bawah' && pkLower === 'sesuai') result = 'Butuh Perbaikan';
        else if (hkLower === 'di bawah' && pkLower === 'di bawah') result = 'Sangat Kurang';
    }
    
    if (result && this.state.optcriteria.length > 0) {
        let opt = this.state.optcriteria.find(x => x.label.toLowerCase() === result.toLowerCase());
        this.setState({ hasilakhirOption: opt || { label: result, value: result } });
    } else if (result) {
        this.setState({ hasilakhirOption: { label: result, value: result } });
    } else {
        this.setState({ hasilakhirOption: null });
    }
  }
  componentDidMount() {
    this.createBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    
        this.createBloc.checkExistingSkpChannel.subscribe((result) => {
        if (result.status === apiResponse.COMPLETED && result.data && result.data.status) {
            console.log("EXISTING SKP DATA:", result.data.response);
            this.setState({ existingSkpData: result.data.response });
        } else if (result.status === apiResponse.ERROR) {
            console.error("ERROR EXISTING SKP DATA:", result.data);
            this.setState({ existingSkpData: [] });
        }
    });

    this.createBloc.employeeChannel.subscribe((result) => {
        switch (result.status) {
            case apiResponse.COMPLETED:
                if(result.data.status) {
                    let response = result.data.response
                    // console.log(response)
                    this.setState({
                        employeeOptions: this.reformatOptionsEmployee(
                            response.result,
                            'employee_full_name',
                            'employee_nip',
                        ),
                        isLoadingOptEmployee: false
                    })
                }
                break
            case apiResponse.ERROR:
                
                break
            default:
                break
        }
    })
    this.createBloc.fetchEmployee()
    
    this.createBloc.positionChannel.subscribe((result) => {
        switch (result.status) {
            case apiResponse.COMPLETED:
                if(result.data.status) {
                    let response = result.data.response
                    // console.log(response)
                    this.setState({
                        positionOptions: this.reformatOptions(
                            response.result,
                            'employee_current_position_name',
                            'is_pltplh',
                        ),
                        isLoadingOptEmployee: false
                    })
                } else {
                    this.setState({ isLoadingOptEmployee: false })
                }
                break
            case apiResponse.ERROR:
                this.setState({ isLoadingOptEmployee: false })
                break
            case apiResponse.ERROR:
                
                break
            default:
                break
        }
    })
    
    
    this.createBloc.individualCriteriaChannel.subscribe((result) => {
        switch (result.status) {
            case apiResponse.COMPLETED:
                if(result.data.status) {
                    let response = result.data.response
                    // console.log(response)
                    this.setState({
                      optcriteria: this.reformatOptions(
                            response.result,
                            'individual_assessment_criteria_name',
                            'individual_assessment_criteria_name',
                        ),
                        isLoadingOptEmployee: false
                    })
                    console.log(this.state.optcriteria);
                }
                break
            case apiResponse.ERROR:
                
                break
            default:
                break
        }
    })
    this.createBloc.fetchIndividualCriteria()
  }

  componentWillUnmount() {
    this.createBloc.createChannel?.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <div className="float-end">
                    <Link
                      to={`?`}
                    >
                      <Button outline color="primary">
                        <i className="uil uil-backward"></i> Kembali
                      </Button>
                    </Link>
                  </div>
                  <CardTitle>Tambah Laporan Penilaian SKP</CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  {this.state.existingSkpData && this.state.existingSkpData.length > 0 ? (
                      <Alert color="info" className="mb-4">
                          <h5 className="alert-heading font-size-15"><i className="uil-info-circle mr-2"></i>Informasi: Data SKP Sudah Tersedia!</h5>
                          <p>Pegawai ini sudah memiliki data SKP untuk periode yang dipilih:</p>
                          <ul className="mb-2">
                              {this.state.existingSkpData.map((d, i) => (
                                  <li key={i}>
                                      <strong>NIP:</strong> {d.nip}, <strong>Nama:</strong> {d.nama}, <strong>Jabatan:</strong> {d.jabatan} {d.is_plt == "Plt" || d.is_plt == "Plh" ? "(" + d.is_plt + ".)" : ""}, <strong>Hasil Kerja:</strong> {d.hasil_kerja}, <strong>Perilaku Kerja:</strong> {d.perilaku_kerja}, <strong>Hasil Akhir:</strong> {d.hasil_akhir}
                                  </li>
                              ))}
                          </ul>
                          <p className="mb-0">Jika Anda tetap melanjutkan (Submit), <strong>maka data yang lama akan terupdate/tertimpa</strong> menggunakan isian data baru yang Anda pilih di bawah ini.</p>
                      </Alert>
                  ) : (
                      this.state.selecttedNIP && !this.state.isLoadingOptEmployee && this.state.existingSkpData !== undefined ? (
                        <Alert color="success" className="mb-4">
                            <h5 className="alert-heading font-size-15 mb-0"><i className="uil-check-circle mr-2"></i>Data SKP untuk pegawai ini pada periode yang dipilih belum tersedia. Silakan lanjutkan pengisian.</h5>
                        </Alert>
                      ) : null
                  )}
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    {/* <Row className="mb-3">
                      <label
                        htmlFor="special_allowance_summary_year"
                        className="col-md-3 col-form-label"
                      >
                        Tahun SKP <span className="text-danger">*</span>
                      </label>
                      <Col md="6">
                        <AvField
                          name="special_allowance_summary_year"
                          placeholder="Tahun SKP..."
                          type="text"
                          errorMessage="Masukkan Tahun SKP"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="special_allowance_summary_year"
                        />
                      </Col>
                    </Row> */}
                    <Row className="mb-3">
                        <label
                          htmlFor="no_skx"
                          className="col-md-3 col-form-label"
                        >
                          Bulan <span className="text-danger">*</span>
                        </label>
                        <Col md="5">
                          <CustomSelect
                            name="period_month"
                            errorMessage="Pilih Bulan"
                            options={this.state.monthOptions}
                            placeholder="Pilih Bulan"
                            defaultValue={this.state.month}
                            onChange={(v) => this.setState({ month: v.value })}
                            isAvForm={false}
                          />

                          <AvField
                            name="month"
                            type="hidden"
                            id="month"
                            value={this.state.month}
                          />
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <label
                          htmlFor="no_skx"
                          className="col-md-3 col-form-label"
                        >
                          Tahun <span className="text-danger">*</span>
                        </label>
                        <Col md="5">
                          <CustomSelect
                            name="period_year"
                            errorMessage="Pilih Tahun"
                            options={this.state.yearOptions}
                            placeholder="Pilih Tahun"
                            defaultValue={this.state.year}
                            onChange={(v) => this.setState({ year: v.value })}
                            isAvForm={false}
                          />

                          <AvField
                            name="year"
                            type="hidden"
                            id="month"
                            value={this.state.year}
                          />
                        </Col>
                      </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="nip"
                            className="col-md-3 col-form-label"
                        >
                        Pegawai <span className="text-danger">*</span>
                        </label>
                        <Col md="5">
                            <CustomSelect 
                                name={`nip`}
                                errorMessage="Pilih Pegawai"
                                options={this.state.employeeOptions} 
                                validate={{ required: { value: true } }}
                                placeholder="Pilih Pegawai"
                                isLoading={false}
                                onChange={(v) => {
                                  this.setState({
                                      selecttedNIP: v.value,
                                      positionOptions:[],
                                      isLoadingOptEmployee: true
                                  }, () => {
                                      this.createBloc.fetchCheckExistingSkp({ nip: v.value, year: this.state.year, month: this.state.month });
                                  })
                                  this.getposition(v.value)
                                }}
                                // defaultValue={data.type}
                            />
                            <AvField
                            name="nip"
                            type="hidden"
                            id="nip"
                            value={this.state.selectedNIP}
                          />
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="nip"
                            className="col-md-3 col-form-label"
                        >
                        Jabatan <span className="text-danger">*</span>
                        </label>
                        <Col md="5">
                            <CustomSelect 
                                name={`is_pltplh`}
                                errorMessage="Pilih Jabatan"
                                options={this.state.positionOptions} 
                                validate={{ required: { value: true } }}
                                placeholder="Pilih Jabatan"
                                // isLoading={this.state.isLoadingOptEmployee}
                                onChange={
                                    (v) => this.setState({
                                        is_pltplh: v.value,
                                        position_name: v.label,
                                    })
                                }
                                // defaultValue={data.type}
                                //test
                            />
                            <AvField
                            name="is_pltplh"
                            type="hidden"
                            id="is_pltplh"
                            value={this.state.is_pltplh}
                          />
                            <AvField
                            name="position_name"
                            type="hidden"
                            id="position_name"
                            value={this.state.position_name}
                          />
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="hasilkerja"
                            className="col-md-3 col-form-label"
                        >
                        Hasil Kerja <span className="text-danger">*</span>
                        </label>
                        <Col md="5">
                            {/* <AvField 
                                name={`hasilkerja`}
                                type="text"
                                errorMessage="Penilaian Harus diisi"
                                // options={this.state.optcriteria} 
                                validate={{ required: { value: true } }}
                                placeholder="Penilaian"
                                // isLoading={this.state.isLoadingOptEmployee}
                                // onChange={
                                //     (v) => this.setState({
                                //         hasilkerja: v.value
                                //     })
                                // }
                                // defaultValue={data.type}
                            /> */}
                            <CustomSelect 
                                name={`hasilkerja`}
                                errorMessage="Pilih Penilaian"
                                options={this.state.hasilperilakuOption} 
                                validate={{ required: { value: true } }}
                                placeholder="Pilih Penilaian"
                                isLoading={false}
                                onChange={(v) => {
                                    this.setState({ hasilkerja: v.value }, () => {
                                        this.calculateHasilAkhir(this.state.hasilkerja, this.state.perilakukerja);
                                    });
                                }}
                                // defaultValue={data.type}
                            />
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="perilakukerja"
                            className="col-md-3 col-form-label"
                        >
                        Perilaku Kerja <span className="text-danger">*</span>
                        </label>
                        <Col md="5">
                            {/* <AvField 
                                name={`perilakukerja`}
                                type="text"
                                errorMessage="Penilaian Harus diisi"
                                // options={this.state.optcriteria} 
                                validate={{ required: { value: true } }}
                                placeholder="Penilaian"
                                // isLoading={false}
                                value={this.state.hasilakhirOption}
                                // defaultValue={data.type}
                            /> */}
                            <CustomSelect 
                                name={`perilakukerja`}
                                errorMessage="Pilih Penilaian"
                                options={this.state.hasilperilakuOption} 
                                validate={{ required: { value: true } }}
                                placeholder="Pilih Penilaian"
                                isLoading={false}
                                onChange={(v) => {
                                    this.setState({ perilakukerja: v.value }, () => {
                                        this.calculateHasilAkhir(this.state.hasilkerja, this.state.perilakukerja);
                                    });
                                }}
                                // defaultValue={data.type}
                            />
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="hasilakhir"
                            className="col-md-3 col-form-label"
                        >
                        Hasil Akhir <span className="text-danger">*</span>
                        </label>
                        <Col md="5">
                            <CustomSelect 
                                name={`hasilakhir`}
                                errorMessage="Pilih Penilaian"
                                options={this.state.hasilakhirOption ? [this.state.hasilakhirOption] : this.state.optcriteria} 
                                validate={{ required: { value: true } }}
                                placeholder="Pilih Penilaian"
                                isLoading={false}
                                isDisabled={true}
                                value={this.state.hasilakhirOption}
                            />
                        </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Upload Dok SKP
                      </label>
                      <Col md="6">
                        <FileInput
                          name="file_doc"
                          accept=".pdf"
                          validate={{ required: { value: false } }}
                          maxFiles={1}
                          isMultiple={false}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to="?">
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          loadingTitle="Mencari Jabatan..."
          loadingInfo="Tunggu beberapa saat"
          showLoading={this.state.isLoadingOptEmployee}
          response={() => {}}
        />
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to="/kepegawaian/skp.html" />
        ) : null}
      </Fragment>
    );
  }
}

export default IndexView;
// aaaaaaaaaaaaaaaaaaaaaa
